import {
    BaseQueryFn,
    createApi,
    fetchBaseQuery,
    FetchArgs,
    FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { normalizeNativeMethod } from './transport';

export const apiBaseUrl = import.meta.env.VITE_APP_API_URL;

const baseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = (args, api, extraOptions) => {
    if (typeof args === 'object' && args !== null) {
        args.method = normalizeNativeMethod(args.method);
    }

    return fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers) => {
            headers.set('Accept', 'application/json');

            const token = localStorage.getItem('token');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    })(args, api, extraOptions);
};

export const unwrapData = <T>(response: { data: T } | undefined): T =>
    response?.data as T;

export const api = createApi({
    reducerPath: 'api',
    tagTypes: [
        'User',
        'Addresses',
        'Discount',
        'PaymentForm',
        'Invoice',
        'Gateway',
        'Marketing',
        'MarketingStatus',
        'MarketingWithdraw',
        'Banks',
        'News',
        'Withdraw',
        'Session',
        'TicketList',
        'Member',
        'Transaction',
    ],
    baseQuery,
    endpoints: () => ({}),
});
